<template lang="pug">
g-navigation-drawer(
  :data="categorizedMenu",
  ref="sidebar",
  :version="buildInfo.version",
  :showBack="false",
  v-bind="{ value }",
  @input="$emit('input', $event)",
)
</template>

<style lang="scss" scoped>
.g-navigation-drawer {
  ::v-deep .os-theme-light > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle {
    background: rgba(0, 0, 0, 0.2);
  }
}
</style>

<script>
import Scrollbar from 'overlayscrollbars'
import axios from 'axios'

export default {
  name: 'sidebar',
  props: {
    value: null,
  },
  data () {
    return {
      buildInfo: {
        version: null,
      },
    }
  },
  computed: {
    menuCategories() {
      return {
         SupplyChain: {
          label: this.$t("Sidebar.supplyChain"),
          icon: "mdi-earth",
          children:[
            { label: this.$tc("Order._name", 1), entity:"Order" },
            { label: this.$tc("OrderLine._name", 1), entity:"OrderLine" },
            { label: this.$tc("Shipment._name", 1), entity:"Shipment" },
            { label: this.$tc("Package._name", 1), entity:"Package" },
            { label: this.$tc("Quote._name", 1), entity:"Quote" },
            { label: this.$tc("Bundle._name", 1), entity:"Bundle" },
            { label: this.$tc("Comment._name", 1), entity:"Comment" },
            { label: this.$tc("File._name", 1), entity:"File" },
            { label: this.$tc("Draft._name", 1), entity:"Draft" }
          ]
        },
        MasterData: {
          label: this.$t("Sidebar.masterData"),
          icon: "mdi-puzzle",
          children:[
            { label: this.$tc("Party._name", 2), entity:"Party" },
            { label: this.$tc("Contact._name", 1), entity:"Contact" },
            { label: this.$tc("Product._name", 1), entity:"Product" },
            { label: this.$tc("ServiceItem._name", 1), entity:"ServiceItem" },
            { label: this.$tc("RateCard._name", 1), entity:"RateCard" },
            { label: this.$tc("Carrier._name", 1), entity:"Carrier" },
            { label: this.$tc("Carrier.typeOfTransport", 1), entity:"TransportType" },
          ]
        },
        Customize: {
          label: this.$t("Sidebar.customize"),
          icon: "mdi-palette",
          children: [
            { label: this.$tc("Counters._name", 1), entity:"Counter"},
            { label: this.$tc("Sidebar.groupExtraFields"), entity:"Group" },
            { label: this.$tc("Status._name", 1), entity:"Status" },
            { label: this.$tc("Report._name", 1), entity:"Report" },
            { label: this.$tc("Chart._name", 1), entity:"Chart" },
            { label: this.$tc("Dashboard._name", 1), entity:"Dashboard" },
            { label: this.$tc("DocumentRequest._name", 1), entity:"DocumentRequest" },
            { label: this.$tc("HandlingUnit._name", 1), entity:"HandlingUnit" },
            // { label: this.$tc("FormRequest._name", 1), entity:"FormRequest" },
            { label: this.$tc("EdiMap._name", 1), entity:"EdiMap"}
          ]
        },
        Automate: {
          label: this.$t("Sidebar.automate"),
          icon: "mdi-robot",
          children: [
            { label: this.$tc("Trigger._name", 1), entity:"Trigger" },
            { label: this.$tc("ActionTemplate._name", 1), entity:"ActionTemplate" },
            { label: this.$tc("Process._name", 1), entity:"Process" },
            { label: this.$tc("Task._name", 1), entity:"Task" },
            { label: this.$tc("Brac._name", 1), entity:"Brac" },
            { label: this.$tc("ReferenceMatrix._name", 1), entity:"ReferenceMatrix" },
            // { label: this.$tc("FormRequest._name", 1), entity:"FormRequest" },
          ]
        },
        Monitor: {
          label: this.$t("Sidebar.monitor"),
          icon: "mdi-desktop-mac",
          children: [
            { label: this.$tc("EdiLog._name", 1), entity:"EdiLog" },
            { label: this.$tc("ErrorLog._name", 1), entity:"ErrorLog" },
            { label: this.$tc("Responsibility._name", 1), entity:"Responsibility" },
            { label: this.$tc("AutomationLog._name", 1), entity:"AutomationLog" },
            { label: this.$tc("ScheduledAction._name", 1), entity:"ScheduledAction" },
          ]
        },
        Access: {
          label: this.$t("Sidebar.access"),
          icon: "mdi-account-box",
          children: [
            { label: this.$tc("BusinessScope._name", 1), entity:"BusinessScope" },
            { label: this.$tc("GroupParty._name", 1), entity:"GroupParty" },
            { label: this.$tc("GroupTask._name", 1), entity:"GroupTask" },
            { label: this.$tc("User._name", 2), entity:"User" },
            { label: this.$tc("Role._name", 1), entity:"Role" },
            { label: this.$tc("Permission._name", 1), entity:"Permission" },
          ]
        }
      }
    },
    filteredEntities() {
      return this.$allNavigableScreens();
    },
    visiblePortals() {
      return this.$store.state.schema.all.filter(e => !e.hidden && e.alias !== null && e.actions.menu == true);
    },
    categorizedMenu() {
      const finalObj = [];
      finalObj.push(...this.staticMenuRoutes());
      const portalRoute = this.createMenuPortals();

      if (portalRoute.children  && portalRoute.children.length) finalObj.push(portalRoute);

      Object.entries(this.menuCategories).forEach(([key, value]) => {
        let categoryItem = {name: value.label, icon: value.icon}
        if(value.children && value.children.length){
          const finalChildren = [];
          value.children.forEach(children => {
            if (children.entity === 'File' && this.authorizedEntities[children.entity]) {
              finalChildren.push({name: this.$tc('File._name', 1), url: `/${this.$scope()}/DocumentFiles`});
            } else {
              if (this.authorizedEntities[children.entity]) {
                finalChildren.push({
                  name: children.label,
                  url: `/${this.$scope()}/${children.entity}`
                });
              }
            }
          });

          categoryItem = finalChildren.length
            ? { ...categoryItem, children: finalChildren }
            : null;
        } else {
          categoryItem = {
            ...categoryItem,
            url: `/${this.$scope()}/${value.label}`
          };
        }

        if (categoryItem) finalObj.push(categoryItem)
      });

      return finalObj;
    },
    authorizedEntities() {
      let authObj = {};
      this.filteredEntities
        .filter(e => e.actions.menu == true)
        .map((e) => ({name: e.name, label: e.label || this.$pascalToHuman(e.name)}))
        .forEach(value => {
          authObj = {...authObj, [value.name]: value}
        });
      return authObj;
    },
  },
  methods: {
    staticMenuRoutes() {
      let staticRoutes = [
        { name: this.$t('Sidebar.workstation'), icon: 'mdi-home', url: `/${this.$scope()}` },
        // { name: 'Document Files', icon: 'mdi-file', url: `/${this.$scope()}/DocumentFiles` }
      ]
      return staticRoutes;
    },
    async fetchVersioning () {
      this.buildInfo = (await axios.get(`appInfo`)).data
    },
    ShowEntityIndex(name) {
      let entity = this.$store.state.schema.all.find(f => name.includes(f.name))
      return entity && entity.actions && entity.actions.index;
    },
    getPortals() {
      let authorizedPortals = {}
      if(this.visiblePortals){
        this.visiblePortals
        .map((e) => ({name: e.name, label: this.$camelToString(e.name)}))
        .forEach(value => {
          authorizedPortals = {...authorizedPortals, [value.name]: value}
        });
      }
      return authorizedPortals
    },
    createMenuPortals() {
      let portalObject = { name: 'Portal', icon: 'mdi-view-dashboard' }
      let authorizedPortals = this.getPortals()
      const finalChildren = []
      // Entities supported for portal label replacement.
      const entities = ['Shipment']

      if (this.ShowEntityIndex('Portal')) {
        finalChildren.push({
          name: this.$t('Sidebar.setUp'),
          url:`/${this.$scope()}/Portal`
        });
      }

      if (authorizedPortals) {
        Object.entries(authorizedPortals).forEach(([key, value]) => {
          // Redirect portal to shipment index instead of portal index, this only
          // works for shipment if you need to support more entities add it into
          // the below array.
          const entity = this.$findEntity(key);
          const valid = entities.includes(entity.alias);

          finalChildren.push(_.assign(
            {
              name: value.label,
              url: `/${this.$scope()}/${key}`,
            },
            valid ? {
              url: `/${this.$scope()}/${entity.alias}/${key}`,
              portal: key
            } : {}
          ));
        });
      }

      portalObject = { ...portalObject, children: finalChildren }

      return portalObject
    },
  },
  mounted () {
    this.fetchVersioning()
    Scrollbar(this.$refs.sidebar.$el.querySelector('.v-navigation-drawer__content'), {
      className: 'os-theme-light',
      scrollbars: {
        autoHideDelay: 300,
        autoHide: 'leave'
      }
    })
  }
}
</script>
